export function setClassPanelAgGrid(className: string) {
    const overlays = document.querySelectorAll('.cdk-overlay-pane');
    overlays.forEach(overlay => {
        const panel = overlay.querySelector('.mat-timepicker-panel');
        const classes = className.split(' ');
        if (panel) {
            classes.forEach((cl) => {
                if (!panel.classList.contains(cl))
                    panel.classList.add(cl);
            })
        }
    });
}
